export const usePaginationHelper = (entity) => {
  const { isMobile } = useBreakpoint();
  const route = useRoute();

  const page = computed(() => Number(route.query?.page) || 1);

  const offset = computed(() => (isMobile.value ? 1 : 3));

  const isShowed = computed(() => {
    return (
      // isDev.value &&
      entity?.data?.value?.meta?.total > entity?.data?.value?.meta?.per_page
    );
  });

  // const isDev = computed(() => {
  //   if (process.client) {
  //     return localStorage.getItem('isDev') === 'true';
  //   }
  //   return false;
  // });

  const paginatePages = computed(() => {
    const arr = [];
    for (
      let i = Math.max(page.value - offset.value, 1);
      i <= Math.min(page.value + offset.value, totalPages.value);
      i++
    ) {
      arr.push(i);
    }
    return arr;
  });

  const totalPages = computed(() => entity?.data?.value?.meta?.last_page ?? 0);

  return { isShowed, paginatePages, offset: offset.value, totalPages, page };
};
